var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColumnStacked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 26,
  width: 5,
  height: 6,
  className: "chart-qualitative-02"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 5,
  width: 5,
  height: 20,
  className: "chart-qualitative-01"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 21,
  width: 5,
  height: 11,
  className: "chart-qualitative-02"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  width: 5,
  height: 20,
  className: "chart-qualitative-01"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 17,
  width: 5,
  height: 15,
  className: "chart-qualitative-02"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 3,
  width: 5,
  height: 13,
  className: "chart-qualitative-01"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 25,
  width: 5,
  height: 7,
  className: "chart-qualitative-02"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 6,
  width: 5,
  height: 18,
  className: "chart-qualitative-01"
})));
export { SvgColumnStacked as ReactComponent };
export default __webpack_public_path__ + "column_stacked.f032ef03b1d30dc739ee71b9c7acfd26.svg";